import React, { ComponentProps, forwardRef } from 'react';

import { IDEALIST_UTM_PARAMS } from 'utils/constants';
import { hasUTMParam, isExternalURL, pathWithParams } from 'utils/url';

import { LegacyPrimaryButton as PrimaryButton } from './LegacyPrimaryButton';

export const PrimaryButtonLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof PrimaryButton>
>( // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ({ href, ...props }, ref) => (
    <PrimaryButton
      href={
        isExternalURL(href) && !hasUTMParam(href)
          ? pathWithParams(href, IDEALIST_UTM_PARAMS)
          : href
      }
      component="a"
      type={null}
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
);
